<div class="container" style="width: 500px">
  <h6 class="uppercase font-28 mb-4">{{'consider-before-calling-the-doctors-apartment' | translate}}:</h6>
  <p class="mb-4">
    {{'according-to-the-state-protocol-for-managing-the-infection-with-covid-19,-you-must-refer-to-the-fever-center.-if-you-suffer-from-at-least-one-of-the-following-symptoms' | translate}}
  </p>
  <ul>
    <li class=" mb-2">
      <div class="text">{{'temperature-37°c-and-above' | translate}}</div>
    </li>
    <li class=" mb-2">
      <div class="text">{{'cold-symptoms:-cough,-runny-nose,-sore-throat,-etc' | translate}}</div>
    </li>
    <li class=" mb-2">
      <div class="text">{{'diarrhea' | translate}}</div>
    </li>
  </ul>
  <p class="mt-4">{{'due-to-the-sharp-increase-in-cases-of-covid-19,-take-advantage-of-the-remote' | translate}}<a
      [queryParams]="{spec: 9, serviceType: 1}"
      [routerLink]="['/search']"
      mat-dialog-close
      target="_blank">{{'video-consultation-of-the-doctor' | translate}}</a></p>
</div>
<button mat-dialog-close>{{'its-clear' | translate}}</button>
